import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  suppliers: "/suppliers",
};

export const fetchSuppliers = createAsyncThunk(
  "suppliers/fetchSuppliers",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.suppliers, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({
          error: error?.response?.data,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createSupplier = createAsyncThunk(
  "suppliers/createSupplier",
  async (supplierData: any, thunkAPI) => {
    try {
      const isFormData =
        typeof FormData !== "undefined" && supplierData instanceof FormData;
      const response = await axiosInstance.post(
        endpoint.suppliers,
        supplierData,
        {
          headers: isFormData
            ? { "Content-Type": "multipart/form-data" }
            : undefined,
        },
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({
          error: error?.response?.data,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const updateSupplier = createAsyncThunk(
  "suppliers/updateSupplier",
  async (data: any, thunkAPI) => {
    try {
      const { slug, ...rest } = data;
      const payload = (rest as any).data ? (rest as any).data : rest;
      const isFormData =
        typeof FormData !== "undefined" && payload instanceof FormData;
      const url = isFormData
        ? `${endpoint.suppliers}/${slug}?_method=PUT`
        : `${endpoint.suppliers}/${slug}`;
      const method = isFormData ? "post" : "put";
      // @ts-ignore
      const response = await axiosInstance[method](url, payload, {
        headers: isFormData
          ? { "Content-Type": "multipart/form-data" }
          : undefined,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({
          error: error?.response?.data,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const deleteSupplier = createAsyncThunk(
  "suppliers/deleteSupplier",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.suppliers}/${slug}`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({
          error: error?.response?.data,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
